
import Navbar from /* webpackChunkName: "Navigation" */ './partials/navigation/Navigation'
import { capitalizeFirstLetter } from '~/fc/Helpers/StringHelpers'
import { updateFreshDeskPageData } from '~/fc/FreshDesk'
import AuthManager from '~/fc/Auth/AuthManager'
import FreshdeskWidgetLoader from '~/components/ui/FreshdeskWidgetLoader'
import { handleTelemetryExpiry } from "~/fc/TelemetryEvents";

export default {
  name: 'FcDashboard',
  components: {
    Alert: () => import(/* webpackChunkName: "Alert" */ '~/components/alert'),
    Navbar,
    FreshdeskWidgetLoader,
    Sidebar: () => import(/* webpackChunkName: "Sidebar" */ '~/components/sidebar'),
    // eslint-disable-next-line vue/no-reserved-component-names
    Footer: () => import(/* webpackChunkName: "Footer" */ '~/layouts/partials/account/footer'),
    ToastContainer: () => import(/* webpackChunkName: "ToastContainer" */ '../components/ui/ToastContainer'),
    BirdEatsBugTrigger: () => import(/* webpackChunkName: "BirdEatsBugTrigger" */ '~/components/ui/BirdEatsBugTrigger')
  },
  data: () => ({
    sidebarClass: ''
  }),
  computed: {
    alertObj() {
      return this.$store.state.alertObj
    },
    pageTitle () {
      const path = this.$route.fullPath.substring(this.$route.fullPath.lastIndexOf('/') + 1)
      return path.split('-').map(x => capitalizeFirstLetter(x)).join(' ')
    },
    authManager () { return new AuthManager(this) }
  },
  watch: {
    '$store.state.sidebarFolded': function () {
      this.setSidebar()
    },
    $route (to, from) {
      updateFreshDeskPageData(this)
      this.authManager.checkExpiryOfToken()
    }
  },
  created () {
    if (process.client) {
      this.$store.dispatch('getLocalSubscription')
    }
  },
  mounted () {
    handleTelemetryExpiry()
    this.authManager.checkExpiryOfToken()
    this.$store.dispatch('getSubscription', this.$auth?.token)
    if (!this.$auth.Token) {
      this.initiateSubscription()
      // backup team join info
      if (window.location.href.includes('/team/join/')) {
        localStorage.setItem('TEAM_JOIN', window.location.href)
        this.$router.push(this.localePath('/auth/free/signup'))
        return
      }
      this.$router.push(this.localePath('/auth/login'))
      return
    }
    // if team join url exist then first user will join the team
    const teamJoinUrl = localStorage.getItem('TEAM_JOIN')
    if (teamJoinUrl) {
      localStorage.removeItem('TEAM_JOIN')
      location.href = teamJoinUrl
    }

    this.setSidebar()
    window.addEventListener('resize', this.setSidebar)
  },
  beforeDestroy () {
    this.$store.commit("setAlert", null);
    window.removeEventListener('resize', this.setSidebar)
  },
  methods: {
    setSidebar () {
      this.sidebarClass = this.$store.state.sidebarFolded
        ? (window.innerWidth > 991 ? 'sidebar-folded' : 'sidebar-open')
        : ''
    },
    initiateSubscription() {
      this.$store.dispatch("getSubscription", this.$auth?.token);
    },
  }
}
